import {
  fetchDealerIntegrations,
  includeIntegrationToDealer,
  excludeIntegrationFromDealer,
} from "@/services/dealerIntegrations";

const Model = {
  namespace: "entityIntegrations",
  state: {
    integrations: [],
  },
  effects: {
    *getDealerIntegrations({ dealerId }, { call, put }) {
      const response = yield call(fetchDealerIntegrations, dealerId);

      yield put({
        type: "setDealerIntegrations",
        payload: response,
      });
    },
    *addIntegrationToDealer({ dealerId, integrationType, integrationId }, { call, put }) {
      const response = yield call(includeIntegrationToDealer, dealerId, integrationType, integrationId);
      yield put({
        type: "addSingleIntegration",
        integration: response,
      });
    },
    *removeIntegrationFromDealer({ integrationId }, { call }) {
      try {
        yield call(excludeIntegrationFromDealer, integrationId);
        return true;
      } catch (error) {
        return false;
      }
    },
  },
  reducers: {
    setDealerIntegrations(state, { payload }) {
      return {
        ...state,
        integrations: payload,
      };
    },
    addSingleIntegration(state, { integration }) {
      return {
        ...state,
        integrations: [...state.integration, integration],
      };
    },
  },
};

export default Model;
